import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Instagram, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Olá! Gostaria de mais informações sobre as aulas no Centro de Lutas Jardim da Penha.");
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        isScrolled ? 'glass-panel shadow-2xl py-2' : 'bg-gradient-to-b from-black/80 to-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-24 lg:h-32">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_jardim-lutas-premium/artifacts/ax3kmr9n_image.png" 
              alt="Centro de Lutas Jardim da Penha" 
              className="h-24 lg:h-32 w-auto transform hover:scale-110 transition-transform duration-300 drop-shadow-[0_0_20px_rgba(220,38,38,0.6)] mix-blend-screen"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('modalidades')} className="nav-link">
              Modalidades
            </button>
            <button onClick={() => scrollToSection('horarios')} className="nav-link">
              Horários
            </button>
            <button onClick={() => scrollToSection('precos')} className="nav-link">
              Planos
            </button>
            <button onClick={() => scrollToSection('depoimentos')} className="nav-link">
              Depoimentos
            </button>
            <button onClick={() => scrollToSection('faq')} className="nav-link">
              FAQ
            </button>
          </nav>

          {/* CTA Button Desktop */}
          <button
            onClick={handleWhatsAppClick}
            className="hidden lg:flex btn-primary"
          >
            Aula Experimental
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-brand-primary"
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black/98 border-t border-border-medium">
          <nav className="container mx-auto px-4 py-6 flex flex-col space-y-4">
            <button onClick={() => scrollToSection('modalidades')} className="nav-link text-left">
              Modalidades
            </button>
            <button onClick={() => scrollToSection('horarios')} className="nav-link text-left">
              Horários
            </button>
            <button onClick={() => scrollToSection('precos')} className="nav-link text-left">
              Planos
            </button>
            <button onClick={() => scrollToSection('depoimentos')} className="nav-link text-left">
              Depoimentos
            </button>
            <button onClick={() => scrollToSection('faq')} className="nav-link text-left">
              FAQ
            </button>
            <div className="pt-4 border-t border-border-medium">
              <button onClick={handleWhatsAppClick} className="btn-primary w-full">
                Aula Experimental
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
